module.exports = __webpack_public_path__ + "translate-4e86cf77d23a8267953a.png";